<template>
  <v-app id="decidedly">
    <v-main class="login-container">
      <v-container
        fluid
      >
        <v-row align="center" justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
            class="pt-6"
          >
            <v-form @submit.prevent="validateLoginForm" class="mt-6">
              <v-card>
                <v-card-title class="d-flex align-center justify-center">
                    <div>
                      <router-link to="/">
                      <v-img
                        alt="Decidedly Logo"
                        :src="require('../assets/logo-blue.svg')"
                        max-width="55"
                      ></v-img>
                      </router-link>
                    </div>
                    <div class="ml-2">
                      <div class="logo-title">
                        Decidedly
                      </div>
                      <div class="text-caption">
                        ALPHA
                      </div>
                    </div>
                </v-card-title>
                <v-card-text>

                  <v-text-field
                    v-model="email"
                    label="email"
                    name="login"
                    prepend-icon="mdi-account"
                    type="email"
                    :error-messages="emailErrors"
                    @blur="$v.email.$touch()"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    v-model="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    :error-messages="passwordErrors"
                    @blur="$v.password.$touch()"
                  ></v-text-field>

                </v-card-text>
                <v-card-actions>
                  <v-btn type="submit" class="ma-6" color="primary" :disabled="$v.email.$invalid || $v.password.$invalid">{{working ? 'Working...' : 'Sign In'}}</v-btn>
                  <v-spacer></v-spacer>
                  <div class="pa-6 text-caption">
                    By signing in, you agree to our <router-link to="/terms" target="_blank">Terms of Service</router-link> and <router-link to="/privacy" target="_blank">Privacy Statement</router-link>.
                  </div>
                </v-card-actions>
              </v-card>
              <div v-if="failedVerification" class="mt-4">
                <div v-if="verificationSent">
                  <v-alert
                    dense
                    type="success"
                  >
                    Thanks! We sent you a new verification email.
                  </v-alert>
                </div>
                <div v-else class="verification-message-wrapper">
                  <v-alert
                    dense
                    type="error"
                  >
                    You still need to verify your email address.
                  </v-alert>
                  <v-alert
                    dense
                    type="info"
                  >
                    Check your email including spam folder for a verification email.<br><br>
                    If the verification link has expired or you cannot find the email
                    <v-btn
                      light
                      small
                      :disabled="working"
                      :loading="working"
                      @click="resendVerification()"
                    >
                      request a new verification email
                    </v-btn>
                  </v-alert>
                </div>
              </div>
              <div v-if="!failedVerification && attempts > 0" class="mt-4">
                <v-alert
                  dense
                  type="error"
                >
                  Incorrect email or password. If you forgot you password you can
                  <v-btn
                    light
                    small
                    :disabled="working"
                    :loading="working"
                    href="/resetpassword"
                  >
                    reset your password
                  </v-btn>
                </v-alert>
              </div>
            </v-form>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'

// Load the auth feature into the firebase namespace.
import 'firebase/auth'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'login',
  components: {
  },
  mixins: [validationMixin],
  data () {
    return {
      email: '',
      password: '',
      working: false,
      verificationSent: false,
      verificationFailed: false,
      errors: [],
      attempts: 0
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    failedVerification () {
      return this.verificationFailed || this.$route.query.failedVerification === 'true'
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid email')
      !this.$v.email.required && errors.push('Email is required.')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required.')
      return errors
    }
  },
  methods: {
    validateLoginForm: async function () {
      // console.log(`Validate called`)
      if (
        this.email &&
        !this.$v.email.$invalid &&
        this.password &&
        !this.$v.password.$invalid
      ) {
        this.login()
      }
      // if (this.email) {
      //   this.login()
      // }
      //
      // this.errors = []
      //
      // if (!this.email) {
      //   this.errors.push({ 'id': 'email', 'message': 'email is required.' })
      // }
    },
    login: async function () {
      // console.log(`Logging in`)
      this.working = true
      this.verificationFailed = false
      let self = this
      if (firebase.auth().currentUser) {
        // Sign out other user
        await firebase.auth().signOut()
      }
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          self.working = false
          if (user && !firebase.auth().currentUser.emailVerified) {
            this.verificationFailed = true
          } else {
            // console.log(`Got a fb user ${user}`)
            // Redirect to the origional from url unless it was the login route itself
            // This can happen if the login succeeds but then the use is redirected back to login due to lack of email veriication.
            // console.log(`From ${this.$route.query.from}`)
            if (this.$route.query.from && this.$route.query.from !== '/login') {
              this.$router.replace(this.$route.query.from)
            } else {
              this.$router.replace('/decisions')
            }
          }
        },
        (/*error*/) => {
          self.working = false
          this.attempts++
          // console.log(error.message)
        }
      )
    },
    resendVerification: function () {
      if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified) {
        const self = this
        firebase.auth().currentUser.sendEmailVerification().then(function () {
          // Email sent.
          self.working = false
          self.verificationSent = true
        }).catch(function (/*error*/) {
          // An error happened
          self.working = false
          // console.log(error)
        })

        // try {
        //   this.working = true
        //   await firebase.auth().currentUser.sendEmailVerification()
        //   this.working = false
        //   this.verificationSent = true
        //   // logger.info('Successfull decoded token')
        // } catch (err) {
        //   this.working = false
        //   console.log(err)
        // }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login-container {
  background: #0e2887;
  /*background-image: url("IMAGE_URL"); fallback */
  background: linear-gradient(#3a52b5, #0e2887); /* W3C */
  /*background-image: linear-gradient(#3a52b5, #0e2887);*/
  color: white;
}
.comparison-list {
  display: flex;
  justify-content: space-around;
}
.logo-title {
  color: #1e40aa;
  text-transform: uppercase;
}
</style>
